export var paymentStateColorMap = function (state) {
    switch (state) {
        case 'REFUNDED':
        case 'CANCELED':
        case 'EXPIRED':
            return 'warning';
        case 'CHARGEBACK':
        case 'PRE_CHARGEBACK':
            return 'secondary';
        case 'REFUND_FAILED':
        case 'REJECTED':
        case 'ERROR':
            return 'error';
        case 'CAPTURED':
        case 'AUTHORIZED':
        case 'SETTLED':
            return 'success';
        case 'SENT_FOR_AUTHORIZATION':
        case 'SENT_FOR_CAPTURE':
        case 'SENT_FOR_CANCEL':
        case 'SENT_FOR_REFUND':
        case 'SENT_FOR_SETTLE':
            return 'default';
        case 'FINGERPRINT_REQUESTED':
        case 'CHALLENGE_REQUESTED':
        case 'PAYER_ACTION_REQUESTED':
        case 'PENDING':
            return 'info';
    }
    return 'default';
};
